/**
 * The seam between the fetch layer and whoever issues tokens.
 *
 * `client.ts` needs an access token per request but has no business knowing that Auth0
 * is where it comes from. Injecting the provider keeps that dependency in one place
 * (main.tsx wires the real one), and means tests supply a token directly instead of
 * module-mocking the SDK.
 */
export type TokenProvider = () => Promise<string | undefined>;

const unset: TokenProvider = () => {
  throw new Error('no token provider: call setTokenProvider() before making a request');
};

let provider: TokenProvider = unset;

export const setTokenProvider = (fn: TokenProvider): void => {
  provider = fn;
};

export const getAccessToken: TokenProvider = () => provider();
